import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../root';
const FUNCTION_CODE = 'UPDATE_DEAL';

export async function updateDeal(
    userToken: string,
    updatedDeal: Record<string, unknown>,
    dealId: string
) {
    try {
        const response = await axios({
            method: 'patch',
            url: `${URL}/deals/${dealId}/`,
            data: updatedDeal,
            headers: {
                Accept: 'application/json',
                Authorization: `Token ${userToken}`
            }
        });

        return response.data;
    }
    catch (error: any) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Erreur lors de la mis à jour de l\'affaire',
            error: error
        });
    }
}
